module.exports = __webpack_public_path__ + "files/572189d106ef6cf5231d2abd0f34a8ca.png";